import { render } from "./vueTextarea.vue?vue&type=template&id=0b0e8223&scoped=true&ts=true"
import script from "./vueTextarea.vue?vue&type=script&lang=ts"
export * from "./vueTextarea.vue?vue&type=script&lang=ts"

import "./vueTextarea.vue?vue&type=style&index=0&id=0b0e8223&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0e8223"]])

export default __exports__